<template>
  <div class="signature-container" :style="`width: ${width}px; height: ${height}px;`">
    <div class="safe-area" :style="`margin: 0 ${safeArea[0]}px ${safeArea[1]}px ${safeArea[0]}px;`"></div>
    <canvas ref="signature"></canvas>
  </div>
</template>

<script>
import SignaturePad from "signature_pad";

export default {
  data() {
    return {
      pad: null,
      width: 500,
      height: 150,
      safeArea: [30, 40],
    };
  },
  mounted() {
    this.width = Math.min(500, window.innerWidth);
    this.height = this.width * 0.3;
    this.safeArea = [this.width * 0.06, this.width * 0.08];

    const canvas = this.$refs.signature;
    canvas.width = this.width;
    canvas.height = this.height;

    this.pad = new SignaturePad(canvas, {
      onEnd: () => {
        this.$emit("change", this.pad);
      },
    });
    this.$emit("ready", this.pad);
  },
  beforeDestroy() {
    this.pad.off();
    this.pad = null;
  },
};
</script>

<style lang="scss" scoped>
.signature-container {
  background: #e0e0e0;
  position: relative;

  canvas {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: transparent;
  }

  .safe-area {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: transparent;
    border-bottom: 1px solid #000;
    margin: 0 30px 40px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/dobrodelen/SignaturePad.vue